import { Modal } from "components";
import { Semantic } from "components/SemanticComponents";
import { useState } from "react";
import { useStoreContext } from "utils/GlobalState";

export default function CalendlyModal(props) {
  const [isIframeLoading, setIsIframeLoading] = useState(true);
  const { state } = useStoreContext();

  const { userObject } = state;
  return (
    <Semantic.Div id={props.div}>
      <Modal.Container closeModal={() => props.setIsCalendlyWidgetOpen(false)}>
        <Modal.Header closeModal={() => props.setIsCalendlyWidgetOpen(false)} />
        <Modal.Body>
          <iframe
            title="Coach Connect On-Demand Booking"
            onLoad={() => setIsIframeLoading(false)}
            src={process.env.REACT_APP_ON_DEMAND_COACH_CONNECT_URL.replace("<contact_hs_vid>", userObject.hubspot_vid)}
            width="60vw"
            height="80vh"
            style={{
              border: "none",
              borderRadius: "8px",
              width: "60vw",
              height: "70vh",
            }}
          />
          {isIframeLoading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,0.7)",
                zIndex: 2,
              }}
            >
              <div
                className="spinner"
                style={{
                  width: 48,
                  height: 48,
                  border: "6px solid #ccc",
                  borderTop: "6px solid #007bff",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                }}
              />
              <style>
                {`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                `}
              </style>
            </div>
          )}
        </Modal.Body>
      </Modal.Container>
    </Semantic.Div>
  );
}
